import React from 'react'
import Link from 'next/link'

import { mergeStyles } from '@enlyt/base'

import defaultStyles from './styles'

const BaseDashboardTile = props => {
  const {
    style,
    icon,
    showCount,
    count,
    title,
    text,
    linkTo,
    linkText,
    modal
  } = props
  const styles = mergeStyles(defaultStyles, style)

  return (
    <div style={styles.container}>
      <div style={styles.topContainer}>
        <div style={styles.iconCountContainer}>
          {icon}
          {showCount && (
            <div style={styles.countContainer}>
              <span style={styles.count}>{count}</span>
            </div>
          )}
        </div>
        <div style={styles.title}>{title}</div>
        <div style={styles.text}>{text}</div>
      </div>
      <div style={styles.bottomContainer}>
        {linkTo && (
          <Link href={linkTo}>
            <span data-cy={linkTo} style={styles.link}>
              {linkText}
            </span>
          </Link>
        )}
        {modal}
      </div>
    </div>
  )
}

export default BaseDashboardTile
